module.exports = __webpack_public_path__ + "static/media/s_v10_7.a513f55d.mp3";